// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__2nvFU","content_spinner":"content_content_spinner__3uKKK"};